import { SVGProps } from 'react';

const CheckIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
        aria-hidden
        {...props}
    >
        <path d="m4 13 5 5L20 6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export default CheckIcon;
